export default __webpack_public_path__ + "c8d2f7aec20701cfd90d2fbed77bf34d.png";